<template>
  <b-modal
    ref="recipeModal"
    title="Product Recipe"
    no-close-on-backdrop
    hide-footer
    @shown="fetchRecipe"
    @hidden="clear"
  >
    <div v-if="!editMode">
      <div
        v-if="recipe !== ''"
        v-html="recipe"
        style="white-space: pre-line"
      ></div>
      <div v-else>
        No recipe specified for this product, click edit to add one.
      </div>
      <button
        class="btn btn-warning mt-5 float-right text-white"
        @click="toggleEditMode"
      >
        Edit
      </button>
      <button
        class="btn btn-light mt-5 float-right text-white mr-2"
        @click="hideModal"
      >
        Close
      </button>
    </div>
    <div v-else>
      <textarea v-model="recipe" class="recipe"></textarea>
      <button
        class="btn btn-success mt-5 float-right text-white"
        @click="updateRecipe"
      >
        Update
      </button>
      <button
        class="btn btn-light mt-5 float-right text-white mr-2"
        @click="toggleEditMode"
      >
        Cancel
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["item"],
  name: "recipe-modal",
  data() {
    return {
      recipe: null,
      editMode: false
    };
  },
  methods: {
    fetchRecipe() {
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/stock/" + this.item + "/recipe")
        .then(
          response => {
            this.recipe = response.data;
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    updateRecipe() {
      let loader = this.$loading.show();
      this.$http
        .post(this.APIURL + this.BRAND + "/stock/" + this.item + "/recipe", {
          recipe: this.recipe
        })
        .then(
          response => {
            this.toggleEditMode();
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    showModal() {
      this.$refs.recipeModal.show();
    },
    hideModal() {
      this.$refs.recipeModal.hide();
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    clear() {
      this.editMode = false;
      this.recipe = null;
    }
  }
};
</script>
<style>
textarea.recipe {
  resize: none;
  width: 100%;
  padding: 10px 20px;
  border-radius: 5px;
  border-color: #ccc;
  height: 200px;
}
</style>
